<!-- Footer -->
<footer class="bg-rose-100 text-center text-sm text-gray-500 py-4 mt-8">
  © {{ currentYear }} Amelia Designs · liebevoll gemacht mit ❤️ ·
  <a routerLink="/legal/privacy" routerLinkActive="underline">Datenschutz</a> ·
  <a routerLink="/legal" routerLinkActive="underline">Impressum</a>
</footer>
<!-- Footer (Ende) -->
